import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { BookAppointementService } from 'src/app/core/services/api-services/book-appointment.service';


@Component({
  selector: 'app-add-patient-group-modal',
  templateUrl: './add-patient-group-modal.component.html',
  styleUrls: ['./add-patient-group-modal.component.scss']
})
export class AddPatientGroupModalComponent implements OnInit {
  AddpatientGroupForm: FormGroup | any;
  locationId: any;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddPatientGroupModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,
    private appointmentService: BookAppointementService
  ) {
    this.locationId = this.data.location;
  }

  ngOnInit(): void {
    this.initializeNote();
  }

  initializeNote() {
    this.AddpatientGroupForm = this.fb.group({
      server_location: [this.locationId, Validators.required],
      name: ['', Validators.required],
    });
  }

  submitForm() {
    if (this.AddpatientGroupForm.valid) {
      const payload = this.AddpatientGroupForm.value;
      this.isLoading = true;
      // Call UserService method to add user insurance
      this.appointmentService.addPatientGroup(payload).subscribe(
        (res: any) => {
          if (res?.body?.success) {
            this.dialogRef.close(res?.body?.success);
            this.toastrService.success(res?.body?.message);
            this.isLoading = false;
          } else {
            this.toastrService.error(res?.body?.message);
            this.dialogRef.close(false);
            this.isLoading = false;
          }
        },
        (error: any) => {
          console.error('Error Patient group create:', error);
          this.dialogRef.close(false);
          this.isLoading = false;
        }
      );
    } else {
      Object.keys(this.AddpatientGroupForm.controls).forEach((field) => {
        const control = this.AddpatientGroupForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      this.isLoading = false;
    }
  }

}
